import * as INR from "../INR.ts";
import * as Html from "../util/Html.ts";
import ApiServer from "../ApiServer.js";
import * as i18n from "../i18n.ts";
import * as modal from "../util/modal.ts";
import * as libLocation from "../lib/location.ts";
import FizConfig from "../FizConfig.js";
import * as Storage from "../lib/Storage.ts";

import TPL from "../mealplanner/recipeDetailShared.mustache";

var theRecipe,renewSessionUrl;
function onApiError(error){
  console.log(error)
  let lastRenew = Storage.sessionGet("lastRenew");
  if(lastRenew==null || (new Date()-new Date(lastRenew)>30000)){
    Storage.sessionSet("lastRenew",new Date().toISOString());
    window.location = renewSessionUrl;
  }else{
    modal.alert("fw2.defaultError")
  }
  
}

function displayRecipe(recipe){
  theRecipe = recipe;
  recipe.rights.canUpdate = false;
  recipe.rights.canDelete = false;
  recipe.canShare = false;
  recipe.canAdd = false;
  recipe.hasCategories = false;
  recipe.signinlink = '<span class="color-branded" data-fw-onclick="ncsaverecipe|signin">'+i18n.get("mp.sharedsignin")+'</span>';
  recipe.registerlink = '<span class="color-branded" data-fw-onclick="ncsaverecipe|register">'+i18n.get("mp.sharedregister")+'</span>';
  
  
  
  Html.setHtml($("#recipe-container"),TPL,recipe);
}

INR.onPage(INR.URL.RECIPEBOX_NC,function(){
  renewSessionUrl = libLocation.getURLParam("re");
  let 
    params = libLocation.extractParam(renewSessionUrl),
    token = params.Tv || params.v,
    recipeId = libLocation.getURLParam("metaId");
  ApiServer.mpncrecipe(token,recipeId,displayRecipe,onApiError)
});

Html.register({
  ncsaverecipe:function(target){
    Storage.sessionSet('recipeToSave',JSON.stringify(theRecipe.originalJson))
    if(target==='register'){
      libLocation.goTo('fw2_signup.php');
    }else{
      libLocation.goTo('fw2_signin.php');
    }
    
  }
})
